import { useTranslation } from "react-i18next";
import { MetaModel } from "../models/meta.model";
import { SiteModel } from "../models/site.model";
import { useSitePhotoUri } from "../../shared/hooks/use-site-photo-uri.hook";

export const useSiteCard = (site: SiteModel) => {
  const { t } = useTranslation();

  const { photoURI, handlerImageError } = useSitePhotoUri(site);

  const metas: MetaModel[] = [
    { value: site.rentalArea, label: t("site.info.rentalArea") },
    { value: site.tenantCount, label: t("site.info.tenantCount") },
    { value: site.lastRehabilitationDate, label: t("site.info.lastRehabilitationDate") },
    { value: site.floorCount, label: t("site.info.floorCount") },
    { value: site.ownerType, label: t("site.info.ownerType") },
  ].filter((meta): meta is MetaModel => meta.value !== null);

  return {
    photoURI,
    handlerImageError,
    metas,
  };
};
